

const TextArea = () => {
    return (
        <textarea readOnly className="keyboard-text-area" placeholder="Type here..."></textarea>
    )
}

export default TextArea